export const MAILCHIMP_ACTION_URL = 'https://sungthecoder.us15.list-manage.com/subscribe/post?u=e416be3e9521392a712ae54e1&amp;id=0f016fe5c6';
export const FORM_SUBMIT_API_KEY = 'c4cfc88bbbce7891944cca2c311a1ed11fac0a890418cc3b5ff3e711a71e35fc';

export default null;



// WEBPACK FOOTER //
// ./src/constants/config.js